import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLoading: false,
    house_number: localStorage.getItem('house_number')
  },
  mutations: {
    Set_Loading(state, payload) {
      state.isLoading = payload;
    }
  },
  actions: {
    setLoading(context, payload) {
      context.commit('Set_Loading', payload);
    }
  },
  modules: {
  },
});
